import { isNotNil } from 'rambda';
import { useFriend } from '@/hooks/contacts/use-friends';
import useGroupMembers from '@/hooks/groups/use-group-members';

interface Options {
  groupId?: number;
  defaultName?: Nullable<string>;
  defaultAvatar?: Nullable<string>;
}

interface UserDisplayInfo {
  name: string;
  avatarUrl: Nullable<string>;
  role: number;
}

export default function useUserDisplayInfo(
  userId: Nullable<number>,
  { defaultName, defaultAvatar, groupId }: Options,
): UserDisplayInfo {
  const isGroup = isNotNil(groupId);

  const { friend } = useFriend(userId);
  const { members: groupMembers } = useGroupMembers(isGroup ? groupId : undefined);

  let name = defaultName;
  let avatarUrl = defaultAvatar;
  let role = 0;

  if (!userId)
    return {
      name: defaultName || '',
      avatarUrl: defaultAvatar || '',
      role,
    };

  name = friend?.RemarkName || (isGroup ? groupMembers[userId]?.GroupMemberName : defaultName) || defaultName;
  avatarUrl = friend?.FriendHeadImg || defaultAvatar;
  role = isGroup ? groupMembers[userId]?.Role || 0 : 0;

  return {
    name: name || '',
    avatarUrl: avatarUrl || '',
    role,
  };
}
